import type { paths } from "@/api-schema";
import { alphartisApiAxios } from "@/config/axios";
import { useQuery } from "@tanstack/react-query";
import { optionsWithDefaults } from "../_helpers/options-with-defaults";
import { Options } from "../_types";

export const APP_ROLE_BY_UUID_RESOURCE = "app-role" as const;
export const APP_ROLE_BY_UUID_API_PATH = `/v1/${APP_ROLE_BY_UUID_RESOURCE}/{uuid}` as const;

export type AppRoleByUuidParameters = paths[typeof APP_ROLE_BY_UUID_API_PATH]["get"]["parameters"]["query"];
export type AppRoleByUuidResponse =
  paths[typeof APP_ROLE_BY_UUID_API_PATH]["get"]["responses"][200]["content"]["application/json"];

export function useAppRoleByUuidQuery(uuid: string, options?: Options<AppRoleByUuidParameters, never>) {
  const optionsWithDefaultsResolved = optionsWithDefaults<Options<AppRoleByUuidParameters, never>>(options);

  const requestParameters = {
    ...(optionsWithDefaultsResolved.parameters || {}),
    extend: optionsWithDefaultsResolved.parameters?.extend || [],
  };

  return useQuery({
    enabled: !!uuid,
    queryKey: [APP_ROLE_BY_UUID_RESOURCE, uuid, { parameters: requestParameters }],
    queryFn: async () => {
      const response = await alphartisApiAxios.get<AppRoleByUuidResponse>(`/v1/${APP_ROLE_BY_UUID_RESOURCE}/${uuid}`, {
        params: requestParameters,
      });

      return response.data;
    },
  });
}
